import React, { Component } from 'react'
import { Button } from 'react-bootstrap';
import jsonlist from '../res/res.json'

import SimpleStorageContract from '../../build/contracts/LPCoin.json'
import getWeb3 from '../utils/getWeb3'

const imgstyle = {
  'position': 'absolute', 
  'margin': 'auto', 
  'top': '0', 
  'left': '0', 
  'right': '0', 
  'bottom': '0',
  'width': 'auto', 
  'height': 'auto', 
  'display': 'block', 
  'maxWidth': "231px",
  'maxHeight': "231px"
};

const imgdivstyle = {
  'width': '233px', 
  'height': '233px', 
  'backgroundColor': '#fff', 
  'margin':'0 auto', 
  'position': 'relative', 
  'borderColor': '#cfcfcf', 
  'borderStyle': 'solid', 
  'borderWidth': '1px',
  'textAlign': 'center', 
  'verticalAlign':'middle'
};

const divstyle = {
  'textAlign': 'center',
  'marginTop': '30px', 
  'marginBottom': '20px'
}

class Home extends Component {

  constructor(props) {
    super(props)

    this.state = {
      web3: null,
      charalist: []
    }
  }

  componentDidMount() {
    getWeb3.then(results => {
      this.setState({ web3: results.web3 })
      this.instantiateContract(0)
    }).catch(() => {
      console.log('Error finding web3.')
    })

    var list = jsonlist.datas;
    var i;
    for ( i in list ) {
      list[i]["lpb"] = "= =";
    }
    this.setState({ charalist: list });
  }

  instantiateContract(i) {
    if (i >= jsonlist.datas.length) return

    const contract = require('truffle-contract')
    const simpleStorage = contract(SimpleStorageContract)
    simpleStorage.setProvider(this.state.web3.currentProvider)

    var simpleStorageInstance;

    var list = this.state.charalist;
    this.state.web3.eth.getAccounts((error, accounts) => {
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.showAllLPBForChara(list[i]["id"])
      }).then((result) => {
        // console.log(result.c[0]);
        list[i]["lpb"] = result.c[0];
        this.setState({ charalist: list }, function () {
           // var ayn = this.state.charalist;
           this.instantiateContract(i+1);
        });
      })
    })
    
  }

  handleClick(e) {
    this.props.history.push({
      pathname: '/wifedetail/'+e
    })
  }

  render() {
    return (
      <div className="Home">
        <main className="container">
          {this.state.charalist.map(function(result, reactid) {
              return (
                <div className="col-sm-6 col-md-4" style={divstyle} key={'ddd'+reactid}>

                  <div style={imgdivstyle}>
                    <img style={imgstyle} src={require('../res/thumbnails/'+result.id+'.jpg')} alt="loading..."></img>
                  </div>

                  <h4>{result.title}</h4>

                  <h4 style={{color: "orange"}}>{result.lpb} LPB</h4>

                  <Button key={'Button'+reactid} onClick={this.handleClick.bind(this, reactid)}>去支持她</Button>

                </div>
              )
          }.bind(this))}
        </main>
      </div>
    );
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/views/Home.js